import { service_handler, is_service_present } from "@/services";
import { get_suggested_booking_dates } from "@liveeps/utilities";

export const search_invadobay_preview_properties = (elem, occupancy = []) => {
  const { checkin, checkout } = get_suggested_booking_dates({
    date_start: elem.search_period_start,
    date_end: elem.search_period_end,
  });
  if (checkout.diff(checkin, "days") < 1) {
    return;
  }

  return service_handler(
    "search",
    {
      checkin,
      checkout,
      occupancy: occupancy,
      suggestion: {
        label: elem.title || elem.name || "",
      },
      filters: {
        invadobay: elem.id,
      },
      order: {
        by: "random",
      },
      limit: 20,
    },
    { modal: false }
  );
};

export const get_invadobays = (slugs = []) => {
  try {
    if (!slugs || !slugs.length || !is_service_present("invadobay.details")) {
      return Promise.resolve([]);
    }

    return service_handler(
      "invadobay.details",
      {
        provider: "expedia", // should this be dynamic on a root level?
        in_vadobay: slugs,
      },
      {
        modal: false,
      }
    ).then((res) => (res.data || {}).data || []); // Normalize here to only return the list
  } catch {
    return Promise.resolve([]);
  }
};

export const get_related_invadobays = (invadobay_id) => {
  try {
    if (!invadobay_id || !is_service_present("invadobay.related")) {
      return Promise.resolve([]);
    }
    return service_handler(
      "invadobay.related",
      {
        provider: "expedia", // should this be dynamic on a root level?
        route_params: {
          id: invadobay_id,
        },
      },
      {
        api_method: "get",
        modal: false,
      }
    ).then((res) => (res.data || {}).data || []); // Normalize here to only return the list
  } catch {
    return Promise.resolve([]);
  }
};

const invadobay_utilities = {
  get_invadobays,
  get_related_invadobays,
  search_invadobay_preview_properties,
};

export default invadobay_utilities;
